import React, { useRef, useEffect } from 'react';
import {
    ModalSubMenuContainer,
    ModalSubMenuHeader,
    ModalSubMenuBody,
    ModalSubMenuItems,
    ModalSubMenuSubtitle,
} from './App.styled';
import { Icon } from "../../elements";

const ModalSubMenu = ({ items, position, title, onClose, avatar=false, subtitle="" }) => {
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    return (
        <ModalSubMenuContainer ref={menuRef} position={position} avatar={avatar} width="auto">
            <ModalSubMenuHeader>
                {title}
                <ModalSubMenuSubtitle>
                    {subtitle}
                </ModalSubMenuSubtitle>
            </ModalSubMenuHeader>
            

            <ModalSubMenuBody>
                {items.map((item, idx) => (
                    <ModalSubMenuItems key={idx} onClick={item.onClick} data-testid={`submenu-item-${item.text.toLowerCase()}`}>
                        {item.icon && (<Icon name={item.icon} height={"16px"} width={"16px"}/>)}
                        {item.text}
                    </ModalSubMenuItems>
                ))}
            </ModalSubMenuBody>
        </ModalSubMenuContainer>
    );
};

export default ModalSubMenu;